









import Vue from 'vue'
import AppInput from '@/components/AppInput/AppInput.vue'
import CenterFormPanel from '@/components/Common/CenterFormPanel.vue'
import BaseLayout from '@/layout/BaseLayout.vue'
import { CompanyActionTypes } from '@/store/modules/companies'
import { Company } from '@/models/companies'

export default Vue.extend({
  components: {
    AppInput,
    CenterFormPanel,
    BaseLayout,
  },

  data() {
    return {
      title: '',
      defaultTitle: '',
    }
  },

  methods: {
    update(): void {
      this.$store.dispatch(CompanyActionTypes.Update, this.title).then(() => {
        this.initFormDataAndDefaultValues()
      })
    },

    deleteCompany(): void {
      this.$useConfirmDialog(
        [
          this.$tc('company.removeConfirm'),
          {
            type: 'danger',
            okText: this.$tc('common.remove'),
            cancelText: this.$tc('common.cancel'),
          },
        ],
        () => {
          this.$store.dispatch(CompanyActionTypes.Delete).then(() => {
            this.$router.push('/scripts')
          })
        },
      )
    },

    initFormDataAndDefaultValues(): void {
      const company: Company = this.$store.getters.getActiveCompany
      this.defaultTitle = this.title = company.title
    },
  },

  computed: {
    /* form check */
    canUpdate(): boolean {
      let result = this.defaultTitle != this.title
      result = result && this.title.length > 0
      return result
    },
  },

  created() {
    this.initFormDataAndDefaultValues()
  },

  metaInfo() {
    return { title: this.$tc('settings.company') }
  },
})
